import BuildCard from '@/components/build/build-card';
import { Spinner } from '@/components/ui/spinner';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { IBuild } from '@/entities/build.entity';
import { BoxIcon } from 'lucide-react';

interface DomainBuildsListProps {
	builds: IBuild[];
	loading?: boolean;
	onInstalled?: () => void;
}

export default function DomainBuildsList({ builds, loading = false, onInstalled }: DomainBuildsListProps) {
	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-4 flex'>
				<div className='flex items-center gap-3'>
					<div className='rounded-lg bg-chart-2/15 p-2'>
						<BoxIcon className='text-chart-2' size={20} />
					</div>
					<div>
						<CardTitle className='text-chart-2'>Сборки на домене</CardTitle>
						<CardDescription>APK, созданные с этим доменом</CardDescription>
					</div>
				</div>
			</CardHeader>

			<CardContent className='px-4 py-4'>
				{loading ? (
					<div className='flex justify-center py-8'>
						<Spinner />
					</div>
				) : builds.length === 0 ? (
					<div className='text-center text-sm text-muted-foreground py-8'>Сборок пока нет</div>
				) : (
					<div className='flex flex-col gap-3'>
						{builds.map(build => (
							<BuildCard key={build.id} build={build} onInstalled={onInstalled} />
						))}
					</div>
				)}
			</CardContent>
		</Card>
	);
}
